// Simply Social wordmark — recreated from the business card
// Serif all-caps with red rules top & bottom, red punctuation.
// Uses CSS variables so it inverts automatically inside `.on-dark` scope.

export default function Logo({ size = "md", tagline = false, className = "" }) {
  const sizes = {
    sm: { text: "text-[0.95rem]", tagline: "text-[0.5rem]", py: "py-1", tracking: "tracking-[0.28em]" },
    md: { text: "text-lg md:text-xl", tagline: "text-[0.55rem] md:text-[0.6rem]", py: "py-1", tracking: "tracking-[0.3em]" },
    lg: { text: "text-xl min-[375px]:text-2xl sm:text-3xl md:text-4xl", tagline: "text-[0.6rem] sm:text-[0.7rem] md:text-[0.75rem]", py: "py-2", tracking: "tracking-[0.22em] sm:tracking-[0.32em]" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex flex-col items-stretch leading-none select-none ${className}`}>
      <div className="h-px w-full" style={{ background: "var(--ss-rust)" }} />
      <div className={`font-display uppercase font-medium ${s.text} ${s.tracking} ${s.py} px-3 whitespace-nowrap`} style={{ color: "var(--ss-cream)" }}>
        Simply<span style={{ color: "var(--ss-rust)" }}>,</span>&nbsp;Social<span style={{ color: "var(--ss-rust)" }}>.</span>
      </div>
      <div className="h-px w-full" style={{ background: "var(--ss-rust)" }} />
      {tagline && (
        <div className={`font-label ${s.tagline} mt-2 text-center`} style={{ color: "var(--ss-rust)" }}>
          Effortless Events. Memorable Moments.
        </div>
      )}
    </div>
  );
}
